import '@fortawesome/fontawesome-free/css/all.min.css'; // Lägg till denna rad först

import React from 'react';
import { createRoot } from 'react-dom/client'; 
import App from './App';

const container = document.getElementById('root');
const root = createRoot(container);
root.render(<App />);
